/**
 * 混入题目跳转、显示逻辑，单页多页均要复用
 */
import { getAllUrlParams } from '@hll/driver-js-utils';
import SingleChoice from '../components/single-choice.vue';
import MultipleChoice from '../components/multiple-choice.vue';
import Judgement from '../components/judgement.vue';
import ScoreTable from '../components/score-table.vue';
import ScoreStar from '../components/star-score.vue';
import Completion from '../components/completion.vue';
import Telphone from '../components/telphone.vue';
import { submitQuestionApi } from '@/api/modules/question';
import { scrollToElementById } from '@/tools/other';
import { dateTimeHms } from '@/tools/tools';
import store from '@/store';
import { isInAllApp } from '@/tools/app.js';

export default {
  props: {
    qdata: {
      // 基础信息
      type: Object,
      default: () => {},
    },
    qlist: {
      // 题目列表
      type: Array,
      default: () => [],
    },
    mode: {
      type: String,
      default: '',
    },
  },
  components: {
    SingleChoice,
    MultipleChoice,
    Judgement,
    ScoreTable,
    ScoreStar,
    Completion,
    Telphone,
  },
  data() {
    return {
      compsMap: {
        1: 'SingleChoice', // 单选
        2: 'MultipleChoice', // 多选
        3: 'Judgement', // 判断
        4: 'ScoreTable', // 量表题
        5: 'ScoreStar', // 打分题
        6: 'Completion', // 填空题
        7: 'Telphone', // 手机号题
      },
      answer_json: [],
      answer_map: {},
      /**
       * 维护每道题的答案所需要隐藏的题目
       * {
       *    1: [3, 4, 5], // 第一题答案需要隐藏 3，4，5题
       *    2: [6, 7] // 第二题答案需要隐藏 6，7题
       * }
       */
      jump_map: {},
      // 以何种状态结束1: 普通跳转（也是正常结束） 2: 正常结束、3: 提前结束
      // 多页模式需要此状态判断
      cur_jump_type: 1,
      // 跳转黑名单
      allJumpList: [],
      // 显示黑名单
      allShowBlackList: [],
    };
  },
  computed: {
    // 所有要隐藏的项
    allHideList: (vm) => {
      return [...vm.allJumpList, ...vm.allShowBlackList];
    },
  },
  mounted() {
    // 初始化子组件传回来的答案
    this.answer_json = this.qlist.map((item) => {
      // 单选题、多选题默认答案为[] 其他为 ""
      const isEmptyArr =
        item.subject_type == 1 || item.subject_type == 2 ? true : false;
      return {
        is_required: item.is_required,
        title_num: item.title_num,
        subject_type: item.subject_type,
        option: isEmptyArr ? [] : '',
        subject_id: item.subject_id,
      };
    });
    // 跳转题场景每道题的jump配置的需要隐藏的题目
    this.jump_map = this.qlist.reduce((acc, cur) => {
      acc[cur.title_num] = [];
      return acc;
    }, {});
    // 初始时就要扫描一遍显示逻辑，找出显示黑名单
    this.allShowBlackList = this.getAllShowBlackList();
  },
  methods: {
    // ===================================跳转逻辑=========================================== //
    // 获取跳转隐藏题目
    getAllJumpList() {
      // 跳转状态置为初始，为多页展示情况服务，如果多页发生提前结束需要将底部按钮变为提交
      this.cur_jump_type = 1;
      for (const item of this.qlist) {
        if (!item.jump) continue;
        switch (item.subject_type) {
          case 1:
          case 3:
            // 单选题、判断题
            this.getSigleORjudge(item);
            break;
          case 2:
          case 6:
          case 7:
            // 多选、填空、手机号
            this.getMultiORComplet(item);
            break;
          case 4:
          case 5:
            // 打分题
            this.getScore(item);
            break;
          default:
            break;
        }
      }
      // 将维护隐藏题目的 map 数组 变成单维数组
      const jumpArr = Object.entries(this.jump_map)
        // 类型统一转换为number
        .map(([titleNum, jumpList]) => {
          const _titleNum = parseInt(titleNum, 10);
          const _jumpList = jumpList.map((n) => parseInt(n, 10));
          return [_titleNum, _jumpList];
        })
        // 顺序排序
        .sort((a, b) => a[0] - b[0])
        // 自上而下，被跳过的题目，其配置的跳过无效
        .reduce((memo, [titleNum, jumpList]) => {
          if (memo.includes(titleNum)) {
            return memo;
          }
          return memo.concat(jumpList);
        }, []);

      return jumpArr;
    },
    // 单选，判断，量表，打分就可以无条件，或者按选项
    // 多选题、填空、手机号 只能无条件

    // 单选题/判断题-获取隐藏题目列表
    getSigleORjudge(item) {
      // 获得当前题目的答案
      const answerItem = this.answer_map[item.title_num] || {};
      // 当前跳转数组
      const curJumpArr = item?.jump?.jump_list || [];
      // 当前跳转状态 1：按选项题跳转 2：无条件跳转
      const curJumpStatus = item?.jump?.jump_status;
      // 当前选中答案
      let curAnswer = '';
      // 单选题
      if (item.subject_type == 1) {
        const option = answerItem.option || [];
        curAnswer = option?.[0]?.option;
      } else {
        // 判断题
        curAnswer = answerItem.option;
      }
      if (!curAnswer) return;
      // 无条件跳转
      if (curJumpStatus === 2) return this.unconditionJump(item);

      // 和该题jump数组里的作对比，确定需隐藏的题目
      for (const v of curJumpArr) {
        if (v.option.includes(curAnswer)) {
          let jumpToNo = v.jump_title_num;
          // jump_type: 0: 不跳转 1: 正常跳转题目  2 正常结束, 3,提前结束的状态，即跳完所有题目 qlist.length + 1
          if (v.jump_type == 0) continue;
          // 跳到底
          if (v.jump_type == 2 || v.jump_type == 3) {
            jumpToNo = this.qlist.length + 1;
            this.cur_jump_type = v.jump_type;
          }
          const arr = this.getJumpNumsArr(item.title_num, jumpToNo);
          this.jump_map[item.title_num] = arr;
          // 找到第一个符合条件的答案即退出for循环
          break;
        } else {
          this.jump_map[item.title_num] = [];
        }
      }
    },
    // 多选题、填空、手机号 ==> 必定是无条件跳转
    getMultiORComplet(item) {
      // 获得当前题目的答案
      const answerItem = this.answer_map[item.title_num] || {};
      // 是否已经作答
      let isAlreadyAnswer = false;
      // 多选题判断是否作答
      if (item.subject_type == 2) {
        isAlreadyAnswer = answerItem?.option?.length > 0;
      } else {
        // 填空题、手机号题判断是否作答
        isAlreadyAnswer = !!answerItem.option;
      }

      if (!isAlreadyAnswer) {
        this.jump_map[item.title_num] = [];
      } else {
        this.unconditionJump(item);
      }
    },

    // 量表题、打分题-获取隐藏题目列表
    getScore(item) {
      // 获得当前题目的答案
      const answerItem = this.answer_map[item.title_num] || {};
      const curAnswer = answerItem.option;
      if (!curAnswer) return;
      // 选择N/A项
      if (Number.isNaN(curAnswer)) {
        this.jump_map[item.title_num] = [];
        return;
      }
      // 当前跳转数组
      const curJumpArr = item?.jump?.jump_list || [];
      // 当前跳转状态 1：按选项题跳转 2：无条件跳转
      const curJumpStatus = item?.jump?.jump_status;

      // 无条件跳转
      if (curJumpStatus === 2) return this.unconditionJump(item);

      for (const v of curJumpArr) {
        if (curAnswer == v.option) {
          let jumpToNo = v.jump_title_num;
          // 不跳转
          if (v.jump_type == 0) continue;
          // 正常结束、提前结束
          if (v.jump_type == 2 || v.jump_type == 3) {
            jumpToNo = this.qlist.length + 1;
            this.cur_jump_type = v.jump_type;
          }
          const arr = this.getJumpNumsArr(item.title_num, jumpToNo);
          this.jump_map[item.title_num] = arr;
          break;
        } else {
          this.jump_map[item.title_num] = [];
        }
      }
    },
    // jump_status: 2 ==> 无条件跳转
    unconditionJump(item) {
      const jumpArr = item.jump.jump_list || [];
      const jumpItem = jumpArr[0] || {};
      let jumpToNo = jumpItem.jump_title_num;

      const jump_type = jumpItem.jump_type;
      // 不跳转
      if (jump_type == 0) return;
      // 跳转到底
      if (jump_type == 2 || jump_type == 3) {
        jumpToNo = this.qlist.length + 1;
        this.cur_jump_type = jump_type;
      }
      const arr = this.getJumpNumsArr(item.title_num, jumpToNo);
      this.jump_map[item.title_num] = arr;
    },
    // ===================================跳转逻辑=========================================== //
    // ===================================显示逻辑=========================================== //
    // 获取显示条件控制的隐藏列表
    getAllShowBlackList() {
      // 显示逻辑黑名单，即不需要展示的题目
      let arr = [];
      for (const item of this.qlist) {
        if (item.show?.condition?.length) {
          const flag = this.checkCurItemIsShow(item.show);
          if (!flag) {
            arr.push(item.title_num);
            this.resetAnswerForHideQuestion(item);
          }
        }
      }
      return arr;
    },
    // 检查配置show的问题是否需要显示
    checkCurItemIsShow(item) {
      // type 0：全部 1：任一
      const type = item.type;
      const condition = item.condition || [];
      let flag = false;
      for (let v of condition) {
        const isJumed = this.allJumpList.includes(v.subject_title_num);
        if (isJumed && type === 0) return; // 假如依赖的题被跳过了并且type: 0全部状态下，当前项直接隐藏
        if (isJumed && type === 1) continue; // 假如依赖的题被跳过了并且type: 1任一状态下，当前条件无效跳过

        flag = this.checkChildCondition(v);
        // 任一情况下 有一个满足即返回true，立即中断循环返回true
        if (type === 1) {
          if (flag) return true;
        } else {
          // 全部情况下，如果有一个不满足，立即终止循环返回false
          if (!flag) return false;
        }
      }
      // 兜底返回最后一次的flag
      return flag;
    },
    // 隐藏的题目重置答案
    resetAnswerForHideQuestion(item) {
      const index = this.answer_json.findIndex(
        (i) => item.title_num === i.title_num,
      );
      const isEmptyArr =
        item.subject_type == 1 || item.subject_type == 2 ? true : false;
      this.answer_json[index].option = isEmptyArr ? [] : '';
    },

    // 检查子condition条件是否满足显示条件
    checkChildCondition(item) {
      // show_type: 0: 填写  1：未填写
      // slect_type: 0: 未选中  1：选中
      // option_type 仅对多选题有用 0: 全部 1: 任一
      const {
        subject_title_num,
        subject_type,
        select_type,
        option,
        option_type,
        show_type,
      } = item;
      const needOption = option || [];
      // 当前题目所依赖的题目
      const answer = this.answer_map[subject_title_num] || {};
      // 所依赖题目的答案
      let aOption = answer.option;
      switch (subject_type) {
        // 单选，判断题，量表题，打分题
        case 1:
        case 3:
        case 4:
        case 5:
          // 单选题答案数据结构和其他题型不一样
          if (subject_type === 1) {
            aOption = aOption?.[0]?.option;
          }
          // 没有答案，直接过掉
          if (!aOption) return false;

          if (select_type === 1) {
            if (needOption.some((o) => o == aOption)) return true; // fix: 防止类型不一致，导致答案匹配不上
          } else {
            if (!needOption.some((o) => o == aOption)) return true;
          }
          return false;
        // 多选题
        case 2:
          aOption = aOption || [];
          if (aOption.length === 0) return false;
          /**
           * 多选题：option_type
           * 0: 全部条件  两个数组完全重叠1(选中条件)，两个数组完全不重叠(未选中条件)
           * 1: 任一条件  两个数组比较是否有元素重叠(部分重叠或全部重叠): 1(有选中)，或是完全不重叠: 0（未选中）
           */
          //
          const arr = aOption.map((v) => v.option);
          // 3种情况分别检查是否符合条件
          return this.checkArrayRepeat(
            needOption,
            arr,
            select_type,
            option_type,
          );
        case 6:
        case 7:
          return (
            (show_type === 1 && !aOption) || (show_type === 0 && !!aOption)
          );
        default:
          break;
      }
    },
    // ===================================显示逻辑=========================================== //

    // 获取两数之间的所有数，组成一个数组
    getJumpNumsArr(min, max = min + 1) {
      let arr = [];
      for (let i = min + 1; i < max; i++) {
        arr.push(i);
      }
      // console.log('min-max===>', min, max, arr);
      return arr;
    },

    /**
     * 检测两个数组是否有重叠或是完全不重叠
     * @param {*} arr1
     * @param {*} arr2
     * @param {*} type 1: 有重叠 0：完全不重叠
     * @param {*} option_type 0: 全部 1: 任一
     */
    checkArrayRepeat(arr1, arr2, type, option_type) {
      const arr1Map = arr1.reduce((acc, cur) => {
        acc[cur] = cur;
        return acc;
      }, {});
      // 完全不重叠
      if (type === 0) {
        return arr2.every((v) => !arr1Map[v]);
      } else {
        // 部分重叠
        if (option_type === 1) {
          return arr2.some((v) => arr1Map[v]);
        } else {
          // 全部重叠
          if (arr1.length === arr2.length) {
            return arr2.every((v) => arr1Map[v]);
          }
          return false;
        }
      }
    },

    /**
     * 接收子组件传来答案的回调
     * answer 当前题目回答
     * index 当前题目索引
     * * item 当前处理的项 (选填)
     */
    handleChange(answer, index, question) {
      this.answer_json[index].option = answer;
      // 判断题, 量表题, 打分题, 需要特殊添加他们的 option_name
      if (this.answer_json[index].subject_type === 3) {
        this.answer_json[index].option_name = question.option.filter(
          (item) => answer === item.option_key,
        )[0].option;
      } else if ([4, 5].includes(this.answer_json[index].subject_type)) {
        console.log('ree');
        this.answer_json[index].option_name = answer;
      }
      console.log('this.answer_json[index]');
      console.log(this.answer_json[index]);

      // 将所有作答题目信息组合成 map
      this.answer_map = this.answer_json.reduce((acc, cur) => {
        acc[cur.title_num] = cur;
        return acc;
      }, {});
      // 跳转逻辑黑名单
      this.allJumpList = this.getAllJumpList();
      // 显示逻辑黑名单
      this.allShowBlackList = this.getAllShowBlackList();
    },

    /**
     * 处理跳转逻辑
     * 跳转类型
     * 1-跳转题目
     * 2-正常结束  is_effective：1
     * 3-提前结束  is_effective：0
     * 跳转到第几题 当jump_type=1时 有效
     * jump_type=3时，直接跳转到最后一题末尾
     */
    handleSubmit() {
      const urlParams = getAllUrlParams(window.location.href);
      if (urlParams.is_preview) {
        this.$hll.toast('预览页提交');
        return;
      }
      const submit_json = this.answer_json.map((item) => {
        return {
          ...item,
          is_skip: this.allHideList.includes(item.title_num) ? 1 : 0,
        };
      });

      const errorIndex = this.checkRequired(submit_json);
      if (errorIndex) {
        this.mode !== 'multi' && scrollToElementById(`form-${errorIndex}`);
        // scrollIntoView 移动端兼容性不好
      } else {
        this.handleSuccess(submit_json);
      }
    },
    // 检查是否有必填项未填，返回第一个未填的必填项题目id
    checkRequired(arr) {
      for (const [index, item] of arr.entries()) {
        if (item.is_skip === 1) continue;
        const title_num = this.checkItemIsPass(item, index);
        if (title_num) {
          this.$hll.toast(`请完整作答第${title_num}题`);
          return title_num;
        }
      }
    },
    // 检查当前项是否通过校验
    checkItemIsPass(item, index) {
      const option = item.option;
      if (item.is_required === 1) {
        const isHaveAnswer = Array.isArray(option)
          ? option.length > 0
          : !!option;
        // 必填项没有填写答案
        if (!isHaveAnswer) {
          return item.title_num;
        }
      }
      // 必填项/非必填项==>允许输入必填情况，只有单选、多选会出现这种情况
      if (Array.isArray(option)) {
        for (const v of option) {
          if (v.is_required && !v.details) {
            return item.title_num;
          }
        }
      }
      // 多选题-非必填情况，限制最小填写数量时校验(即答题数量不满足最小需答数量)
      if (item.subject_type == 2 && item.option?.length) {
        const min = this.qlist[index]?.option_set?.min;
        const len = item.option?.length;
        if (min && len < min) {
          return item.title_num;
        }
      }
      // 手机号题-如果非必填情况，但是已经填写并且不符合手机号规则也要拦截
      if (
        item.subject_type == 7 &&
        item.option &&
        !/^1[3-9]\d{9}$/.test(item.option)
      ) {
        return item.title_num;
      }
    },
    // 提交成功
    handleSuccess(submit_json) {
      const urlParams = getAllUrlParams(window.location.href);
      const endTime = Date.now();
      // 开始时间在vuex初始化的state里面
      const startTime = store.state.app.startTime;
      const timeDiff = (endTime - startTime) / 1000;
      const timeStr = dateTimeHms(timeDiff);

      const reqParam = {
        id: urlParams.id, //记录司机
        questionnaire_id: urlParams.questionnaire_id,
        is_effective: this.cur_jump_type === 3 ? 0 : 1, // 0: 提前提交 1: 正常提交
        push_id: urlParams.push_id || '',
        original_from: urlParams.original_from,
        answer_json: { subjects: submit_json },
        answer_at: timeStr,
      };
      console.log(urlParams.is_login, isInAllApp);
      if (
        urlParams.is_login === '0' &&
        (!isInAllApp || urlParams.not_logged_in_force == 1)
      ) {
        reqParam['not_logged_in'] = 10014;
      }
      if (!isInAllApp && !urlParams.original_from) {
        reqParam['original_from'] = 99999999999999;
      }
      submitQuestionApi(reqParam).then((res) => {
        if (res.ret == 0) {
          this.$hll.toast('提交成功');
          setTimeout(() => {
            this.goNextPage();
          }, 800);
        } else {
          this.$hll.toast(res.msg);
        }
      });

      console.log('reqParam===>', reqParam);
    },
    // 提交成功如何跳转
    goNextPage() {
      const end_page = this.qdata.end_page || {};
      let action = end_page.normal_completion || {};
      // 提前结束
      if (this.cur_jump_type == 3) {
        action = end_page.early_completion || {};
      }

      // status: 3 提前完成  2: 正常完成
      const status = this.cur_jump_type === 3 ? 3 : 2;
      // type 1: 显示文案 2：跳转页面
      if (action.type == 1) {
        const url = `/question/result?status=${status}&tips=${action.jump_link}`;
        this.$router.push(url);
      } else {
        // 跳转链接兜底添加协议
        let jump_link = action.jump_link;
        if (!/^https?:\/\//i.test(jump_link)) {
          jump_link = `https://${jump_link}`;
        }
        if (
          /^(https?:\/\/)?(www\.)?(.+\.)?xiaolachuxing\.com(?:\/|$)/i.test(
            jump_link,
          )
        ) {
          const urlParams = getAllUrlParams(window.location.href);
          let urlString = '';
          for (const key in urlParams) {
            urlString += '&' + key + '=' + urlParams[key];
          }
          let url = '';
          const jump_link_obj = new URL(jump_link);
          if (jump_link_obj.search !== '') {
            url = jump_link + urlString;
          } else {
            url = jump_link + '?' + urlString.slice(1);
          }

          window.location.href = url;
        } else {
          window.location.href = jump_link;
        }
      }
    },
  },
};
